import { useEffect, useRef, useState } from "react";
import Loading from "../../Loading";
import { ContentContainer, GerarPedidoComprasModalContainer } from "./styles";
import LogoVestaPng from "../../../assets/mdias_vesta-grande.png";
import tracinhoImg from "../../../assets/tracinho.png";
import { getBase64FromUrl } from "../../../utils/files";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
pdfMake.vfs = pdfFonts.pdfMake.vfs

Chart.register(ChartDataLabels);

export const GerarRelatorioProposta = ({
    setModalOpened,
    orcamento,
    quantidade
}) => {
    const [loading, setLoading] = useState(true);
    const [logo, setLogo] = useState("");
    const [tracinho, setTracinho] = useState("");
    const [orcamentoProposta, setOrcamentoProposta] = useState(false);
    const [orcamentoSelecionado, setOrcamentoSelecionado] = useState({});
    const [grafico, setGrafico] = useState("");
    const [especificacoes, setEspecificacoes] = useState("");
    const canvasRef = useRef(null);

    const tipoSaving = {
        "trabalho-urgente": "Trabalho Urgente",
        "patente": "Patente",
        "desenvolvimento-fornecedor": "Desenvolvimento Fornecedor",
        "repeticao-dentro-do-ano": "Repetição Dentro do Ano",
        "media-de-mercado": "Média de Mercado",
        "reengenharia": "Reengenharia",
        "repeticao-exata": "Repetição Exata",
        "tco": "TCO",
        "similaridade": "Similaridade",
    }

    function relatorioDisputa() {
        api
            .get(
                `/relatorios/proposta/${orcamento.find((elem) => elem.quantidade == quantidade).id}`
            )
            .then((response) => {
                const dados = response.data.data.dados
                setOrcamentoProposta(dados);
                setOrcamentoSelecionado(dados.outros_orcamentos.find((elem) => elem.escolhido));
                const teste = dados.categoria === "Brindes"
                    ? ` Observação: ${dados.descricao} | Público Alvo: ${dados.publico_alvo
                    } | Item de Marca: ${dados.item_de_marca ? "Sim" : "Não"
                    }`
                    : dados.categoria === "Material Impresso"
                        ? ` Observação: ${dados.descricao} | Quantidade de páginas: ${dados.quantidade_de_paginas
                        } | Formato aberto: ${dados.formato_aberto
                        }cm | Formato fechado: ${dados.formato_fechado
                        }cm | Tipo de Papel: ${dados.substrato} | Gramatura: ${dados.gramatura
                        } | Cores: ${dados.cores} | Acabamentos: ${dados.acabamentos
                        }]`
                        : dados.categoria == "Ponto de Venda"
                            ? ` Observação: ${dados.descricao} | Substrato: ${dados.substrato
                            } | Espessura: ${dados.espessura} | Cores: ${dados.cores
                            } | Acabamentos: ${dados.acabamentos
                            } | Necessário Positivação: ${dados.positivacao ? "Sim" : "Não"
                            } ]`
                            : dados.categoria === "Comunicação Visual"
                                ? ` Observação: ${dados.descricao} | Tamanho Final: ${dados.tamanho
                                } | Formato aberto: ${dados.formato_aberto}cm | Substrato: ${dados.substrato
                                } | Gramatura: ${dados.gramatura} | Cores: ${dados.cores
                                } | Acabamentos: ${dados.acabamentos
                                } | Necessário Positivação: ${dados.positivacao ? "Sim" : "Não"
                                }`
                                : `assa`
                setEspecificacoes(teste);
            })
            .catch(() => {
                toast.error("Erro ao buscar relatório.");
            });
    }

    useEffect(() => {
        if (!canvasRef.current || !orcamentoProposta) return;
        const dpr = 3;
        const canvas = canvasRef.current;
        canvas.width = 600 * dpr;
        canvas.height = 300 * dpr;
        const ctx = canvas.getContext("2d");
        ctx.scale(dpr, dpr);

        const chart = new Chart(ctx, {
            type: "bar",
            data: {
                labels: orcamentoProposta ? orcamentoProposta.outros_orcamentos.map((elem) => elem.fornecedor_nome) : ["MARTHA", "SINCOPLASTIC", "PLAST LOG"],
                datasets: [
                    {
                        label: "TOTAL",
                        data: orcamentoProposta ? orcamentoProposta.outros_orcamentos.map((elem) => Number(elem.valor_de_venda)) : [0, 0, 0],
                        backgroundColor: "#004d66",
                    },
                ],
            },
            layout: {
                padding: {
                    top: 50, // espaço extra no topo
                },
            },
            options: {
                scales: {
                    y: {
                        ticks: { font: { size: 30 } },
                        suggestedMax: Math.max(...orcamentoProposta.outros_orcamentos.map(e => Number(e.valor_de_venda))) * 1.1
                    },
                    x: { ticks: { font: { size: 30 } } }
                },
                responsive: false,
                animation: false,
                plugins: {
                    legend: { labels: { font: { size: 30 } }, position: "bottom" },
                    datalabels: {
                        font: { size: "30px" },
                        color: "#fff",
                        anchor: "center",
                        align: "center",
                        formatter: (value) => {
                            const metade = value / orcamentoProposta.quantidade;
                            return `R$ ${metade.toLocaleString("pt-BR", {
                                minimumFractionDigits: 2,
                            })}`;
                        },
                    },
                },
            },
            plugins: [
                {
                    id: "topLabels",
                    afterDatasetsDraw(chart) {
                        const { ctx } = chart;
                        chart.data.datasets.forEach((dataset, i) => {
                            const meta = chart.getDatasetMeta(i);
                            meta.data.forEach((element, index) => {
                                ctx.fillStyle = "#7D0000";
                                ctx.font = "bold 30px sans-serif";
                                ctx.textAlign = "center";
                                ctx.textBaseline = "bottom";
                                const value = dataset.data[index];
                                const x = element.x;
                                const y = element.y - 3;
                                ctx.fillText(
                                    `R$ ${value.toLocaleString("pt-BR", {
                                        minimumFractionDigits: 2,
                                    })}`,
                                    x,
                                    y
                                );
                            });
                        });
                    },
                },
            ],
        });

        // depois que monta, pega a imagem base64
        setTimeout(() => {
            const base64 = chart.toBase64Image("image/png");
            setGrafico(base64);
        }, 300);

        return () => chart.destroy();
    }, [orcamentoProposta]);

    useEffect(() => {
        getBase64FromUrl(LogoVestaPng).then((response) => {
            setLogo(response);
            relatorioDisputa();
        });
        getBase64FromUrl(tracinhoImg).then((response) => setTracinho(response));
    }, [orcamentoProposta]);

    const generatePDF = async () => {

        var docDefinition = {
            pageMargins: [0, 0, 0, 0],
            background: [
                {
                    image: logo,
                    width: 595,
                    height: 842,
                }
            ],
            content: [
                {
                    text: `TRILHA DO PROCESSO DE COMPRAS`,
                    style: "title",
                    color: "white",
                    bold: true,
                },
                {
                    margin: [120, 15, 0, 0],
                    text: [
                        { text: "JOB: ", color: "white", bold: true },
                        { text: `${orcamentoProposta.nome} ${orcamentoProposta.subnome}`, color: "white" },
                    ],
                    style: "subheader",
                },
                {
                    margin: [116, 0, 0, 0],
                    text: [
                        { text: "ITEM: ", color: "white", bold: true },
                        { text: `${orcamentoProposta.item}`, color: "white" },
                    ],
                    style: "subheader",
                },
                {
                    margin: [85, 0, 0, 0],
                    text: [
                        { text: "CATEGORIA: ", color: "white", bold: true },
                        { text: `${orcamentoProposta.categoria}`, color: "white" },
                    ],
                    style: "subheader",
                },
                {
                    margin: [78, 0, 0, 0],
                    text: [
                        { text: "QUANTIDADE: ", color: "white", bold: true },
                        { text: `${orcamentoProposta.quantidade}`, color: "white" },
                    ],
                    style: "subheader"
                },
                {
                    margin: [25, 0, 0, 0],
                    text: [
                        { text: "VALIDADE DO PROCESSO: ", color: "white", bold: true },
                        { text: "30 DIAS CORRIDOS", color: "white" },
                    ],
                    style: "subheader",
                },
                {
                    margin: [440, -50, 0, 0],
                    text: [
                        { text: "NCM: ", color: "white", bold: true },
                        { text: `${orcamentoProposta.ncm ? orcamentoProposta.ncm : "N/A"}`, color: "white" },
                    ],
                    style: "subheader",
                },
                {
                    margin: [447, 0, 0, 0],
                    text: [
                        { text: `${orcamentoProposta.categoria == "Serviço" ? "ISS: " : "IPI:"}`, color: "white", bold: true },
                        { text: `${orcamentoProposta.categoria == "Serviço" ? orcamentoSelecionado.item_iss : orcamentoProposta.ipi ? orcamentoProposta.ipi : "N/A"} %`, color: "white" },
                    ],
                    style: "subheader",
                },
                {
                    margin: [406, 0, 0, 0],
                    text: [
                        { text: "UTILIZAÇÃO: ", color: "white", bold: true },
                        { text: "SEMI - PERMANENTE", color: "white" },
                    ],
                    style: "subheader",
                },
                //Titulo da tabela
                {
                    margin: [80, 60, 0, 0],
                    text: "RESUMO DA NEGOCIAÇÃO",
                    style: "title2",
                    color: "#7D0000",
                    bold: true,
                },
                {
                    columns: [
                        {
                            text: [
                                { text: "VALOR " },
                                { text: "UNITÁRIO ", bold: true },
                                { text: "DE COMPRAS " },
                                { text: "SEM IPI", bold: true },
                                { text: ":  R$" },
                                {
                                    text: `             ${(orcamentoSelecionado?.valor_sem_ipi / orcamentoProposta.quantidade).toLocaleString("pt-BR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`
                                }
                            ],
                            fontSize: 9,
                            margin: [30, 10, 20, 0],
                        }
                    ]
                },
                {
                    columns: [
                        {
                            text: [
                                { text: "VALOR ", },
                                { text: "TOTAL ", bold: true },
                                { text: "DE COMPRAS ", },
                                { text: "SEM IPI", bold: true },
                                { text: ":  R$", },
                                {
                                    text: `             ${Number(orcamentoSelecionado?.valor_sem_ipi).toLocaleString("pt-BR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`
                                }
                            ],
                            fontSize: 9,
                            margin: [43, 5, 20, 0],
                        }
                    ]
                },
                {
                    columns: [
                        {
                            text: [
                                { text: "VALOR ", },
                                { text: "UNITÁRIO ", bold: true },
                                { text: "DE COMPRAS ", },
                                { text: "COM IPI", bold: true },
                                { text: ":  R$", },
                                {
                                    text: `             ${(orcamentoSelecionado?.valor_total / orcamentoProposta.quantidade).toLocaleString("pt-BR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`
                                }
                            ],
                            fontSize: 9,
                            margin: [29, 5, 20, 0],
                        }
                    ]
                },
                {
                    columns: [
                        {
                            text: [
                                { text: "VALOR ", },
                                { text: "TOTAL ", bold: true },
                                { text: "DE COMPRAS ", },
                                { text: "COM IPI", bold: true },
                                { text: ":  R$", },
                                {
                                    text: `             ${Number(orcamentoSelecionado?.valor_total).toLocaleString("pt-BR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`
                                }
                            ],
                            fontSize: 9,
                            margin: [42, 5, 20, 0],
                        }
                    ]
                },
                {
                    columns: [
                        {
                            width: 320,
                            text: [
                                { text: "FORNECEDOR: ", },
                                { text: `${orcamentoProposta.fornecedor} ${orcamentoProposta.fornecedor_documento}` }
                            ],
                            fontSize: 9,
                            margin: [20, 5, 20, 0],
                            alignment: "right"
                        }
                    ]
                },
                {
                    columns: [
                        {
                            text: [
                                { text: "HONORÁRIOS VESTA: ", },
                                {
                                    text: `  R$             ${Number(orcamentoSelecionado?.honorarios_vesta).toLocaleString("pt-BR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`
                                },
                            ],
                            fontSize: 9,
                            margin: [103, 5, 20, 0],
                        }
                    ]
                },
                {
                    columns: [
                        {
                            text: [
                                { text: "VALOR TOTAL INVESTIMENTO: ", },
                                { text: "  R$" },
                                {
                                    text: `             ${Number(orcamentoSelecionado?.valor_de_venda).toLocaleString("pt-BR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })
                                        }`
                                }
                            ],
                            fontSize: 9,
                            margin: [66, 5, 20, 0],
                        }
                    ]
                },
                {
                    image: tracinho,
                    width: 8,
                    height: 130,
                    margin: [310, -123, 0, 0],
                },
                {
                    margin: [420, -143, 0, 0],
                    text: "SAVING",
                    styled: "title2",
                    color: "#7D0000",
                    bold: true,
                },
                {
                    margin: [350, 10, 20, 0],
                    fontSize: 9,
                    text: [
                        { text: "VALOR UNITÁRIO BASELINE: ", },
                        { text: "R$ ", },
                        {
                            text: `        ${(Number(orcamentoProposta.baseline) / Number(orcamentoProposta.quantidade)).toLocaleString("pt-BR", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`
                        }
                    ],
                },
                {
                    margin: [407, 10, 20, 0],
                    fontSize: 9,
                    text: [
                        { text: "SAVING REAL: ", },
                        { text: "R$ ", },
                        { text: `         ${orcamentoProposta.saving ? orcamentoProposta.saving : 0} % ` }
                    ],
                },
                {
                    margin: [371, 10, 20, 0],
                    fontSize: 9,
                    text: [
                        { text: "VALOR TOTAL SAVING: ", },
                        { text: "R$ ", },
                        {
                            text: `         ${orcamentoProposta.saving_real ? Number(orcamentoProposta.saving_real).toLocaleString("pt-BR", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) : "0,00"} `
                        }
                    ],
                },
                {
                    margin: [350, 15, 20, 0],
                    text: "OPÇÕES DE DESTINO DE SAVING",
                    color: "#7D0000",
                    bold: true
                },
                {
                    margin: [400, 5, 20, 0],
                    fontSize: 8,
                    text: [
                        { text: "1 - SAVING FINANCEIRO: ", },
                        { text: tipoSaving[orcamentoProposta.tipo_saving], color: "#7D0000", fontSize: tipoSaving[orcamentoProposta.tipo_saving]?.length > 30 ? 6 : 8 },
                    ],
                },
                { text: `(   )`, margin: [560, -13, 0, 0] },
                {
                    margin: [364, 5, 20, 0],
                    fontSize: 8,
                    text: [
                        { text: "2- INVESTIMENTO EM PRODUÇÃO: ", },
                        { text: `${Number(orcamentoProposta.saving) + 2} % `, color: "#7D0000" },
                    ],
                },
                { text: `(   )`, margin: [560, -13, 0, 0] },
                {
                    margin: [320, 5, 20, 0],
                    fontSize: 8,
                    text: [
                        { text: "3- NEUTRALIZAÇÃO DA PEGADA DE CARBONO: ", },
                        { text: ``, color: "#7D0000" },
                    ],
                },
                { text: `(   )`, margin: [560, -13, 0, 0] },
                { text: "ESPECIFICAÇÕES DO ITEM", margin: [20, 40, 0, 0], color: "#7D0000", bold: true },
                {
                    text: `${especificacoes}`,
                    margin: [20, 8, 0, 0],
                    fontSize: 10,
                },
                {
                    text: "CONCORRÊNCIA",
                    style: "title2",
                    color: "#7D0000",
                    bold: true,
                    alignment: "center",
                    margin: [0, 20, 0, 10],
                },
                grafico
                    ? {
                        image: grafico,
                        width: 520,
                        height: 250,
                        alignment: "center",
                        margin: [0, 10, 0, 20],
                    }
                    : {},
                {
                    text: "OBSERVAÇÕES GERAIS",
                    style: "title2",
                    color: "#7D0000",
                    bold: true,
                    alignment: "center",
                    margin: [0, 20, 0, 10],
                },
                {
                    text: `${orcamentoProposta.observacoes || "Nenhuma observação."}`,
                    margin: [20, 8, 0, 0],
                    fontSize: 10,
                }
            ],
            styles: {
                title: {
                    fontSize: 14,
                    bold: true,
                    margin: [180, 20, 0, 0],
                },
                teste: {
                    background: "#7D0000",
                    margin: [0, 0, 0, 300],
                },
                dadosCliente: {
                    fontSize: 10,
                },
                subheader: {
                    fontSize: 10,
                    margin: [120, 0, 0, 0],
                },
                title2: {
                    fontSize: 12,
                }
            },
        };

        pdfMake.createPdf(docDefinition).getBlob((blob) => {
            const fileURL = URL.createObjectURL(blob);
            const newWindow = window.open(fileURL, "_blank", "noopener,noreferrer");
            if (newWindow) newWindow.opener = null;
            setOrcamentoProposta(false);
            setLogo("");
            setTracinho("");
            setModalOpened(false);
        });
    };

    useEffect(() => {
        if (logo && orcamentoProposta && tracinho && grafico) {
            generatePDF();
        }
    }, [logo, orcamentoProposta, grafico]);

    return (
        <GerarPedidoComprasModalContainer>
            <ContentContainer>{loading && <Loading />}</ContentContainer>
            <canvas ref={canvasRef} width={600} height={300} style={{ display: "none" }} />
        </GerarPedidoComprasModalContainer>
    );
};